import script from "./DocumentUploadField.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentUploadField.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentUploadField.vue?vue&type=style&index=0&id=bd02d9ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd02d9ba"]])

export default __exports__